import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import MaterialList from "./components/MaterialList";
import MaterialStock from "./components/MaterialStock";
import MaterialCategoryList from "./components/MaterialCategoryList";
import TabPanel from "../../../components/TabPanel";
import { a11yProps } from "../../../utils/common";

function MaterialManagementIndex() {
  const location = useLocation();
  const defaultTab = location.state?.tab !== undefined ? location.state.tab : 0;
  const [tabValue, setTabValue] = useState(defaultTab);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="Material Management Tabs">
          <Tab label="Material Category" {...a11yProps(0)} />
          <Tab label="Material Master" {...a11yProps(1)} />
          <Tab label="Material Stock" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <MaterialCategoryList />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <MaterialList />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <MaterialStock />
      </TabPanel>
    </Box>
  );
}

export default MaterialManagementIndex;
